import { useState } from "react";
import { useSelectableIncidentAffectedServicesQuery } from "@common/hooks/useSelectableItemQueries.ts";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider.tsx";
import { IncidentLogAffectedServicesFieldProps } from "./IncidentLogAffectedServicesField.tsx";

export function useIncidentLogAffectedServicesField(props: IncidentLogAffectedServicesFieldProps) {
    const { permissions } = useUserContext();
    const [searchValue, setSearchValue] = useState("");
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const incidentAffectedServicesQuery = useSelectableIncidentAffectedServicesQuery(!props.isPreview);

    const openCreateDialog = () => {
        setShowCreateDialog(true);
    };

    const closeCreateDialog = () => {
        setShowCreateDialog(false);
    };

    const onIncidentAffectedServiceCreated = (incidentAffectedServiceId: string) => {
        props.onChange([...props.affectedServiceIds, incidentAffectedServiceId]);
        setShowCreateDialog(false);
        setSearchValue("");
        incidentAffectedServicesQuery.refetch();
    };

    return {
        isLoading: incidentAffectedServicesQuery.isLoading,
        incidentAffectedServices: incidentAffectedServicesQuery.data,
        canCreateIncidentAffectedService: permissions.canManageMasterData,
        searchValue,
        setSearchValue,
        showCreateDialog,
        openCreateDialog,
        closeCreateDialog,
        onIncidentAffectedServiceCreated,
    };
}
